import React, { useCallback, useEffect, useState } from 'react';
import { Input, InputNumber, Popconfirm, Form, Space, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { PlusOutlined, DeleteTwoTone } from '@ant-design/icons';
import _, { isEmpty, isNil, sumBy } from 'lodash';

import { toCurrency } from 'utils/utils';
import { useFormList } from 'hooks/useFormList';
import { shouldUpdateCompare } from 'utils/utils2';
import Value from 'components/Value';
import Button from 'components/Button';
import DataGrid from 'components/DataGrid';
import TaxSelect from 'components/TaxSelect';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { SuppInvoiceLineResponse } from 'services/supplierInvoice';
import { Text } from '@react-pdf/renderer';
import ButtonOperation from 'components/ButtonOperation';
import InputCurrency from 'components/InputCurrency';
import { findSIBeneficiary } from 'services/thirdParty';
import moment from 'moment';
import { MgWithHoldingTax } from 'services/parametersService';
import InputRate from 'components/InputRate';

const { Option } = Select;
type TabSuppInvoiceLinesProps = {
  form: FormInstance;
  siid: number | undefined;
  ctrid: number | undefined;
  simultiplecontracts: boolean;
};

const TabSuppInvoiceLines = (props: TabSuppInvoiceLinesProps) => {
  const { form, siid, simultiplecontracts, ctrid } = props;

  const fieldNameLine = 'suppInvoiceLines';
  const [benefTresor, setbenefTresor] = useState<any>();
  const [newDatebenef, setnewDatebenef] = useState<any>();
  const { add: addLine, remove: removeLine } = useFormList(
    form,
    fieldNameLine,
    {
      addAsFirst: true,
      idKey: 'silid',
    }
  );
  const fieldNameSch = 'suppInvoiceSchedules';

  const { add: addsch, remove: removesch } = useFormList(form, fieldNameSch, {
    addAsFirst: true,
    idKey: 'sisid',
  });

  if (form.getFieldValue(fieldNameLine) === undefined) {
    form.setFieldsValue({
      [fieldNameLine]: [],
    });
  }

  useEffect(() => {
    if (
      isNil(siid) ||
      (form.getFieldValue('sistatus') === 'INIT' &&
        form.getFieldValue('isUpdating'))
    ) {
      let array = form.getFieldValue(fieldNameLine);
      const silnettotalamount = sumBy(array, 'silnettotalamount');
      const sitaxtotal = sumBy(array, 'siltaxtotalamount');
      const sigrosstotal = isNil(sumBy(array, 'sisamount'))
        ? sumBy(array, 'silgrosstotalamount')
        : sumBy(array, 'sisamount');
      form.setFieldsValue({ sitaxtotal, silnettotalamount, sigrosstotal });
      for (let i = 0; i < array.length; i++) {
        let taxrate = array[i]?.siltaxrate
          ? array[i]?.siltaxrate
          : array[i]?.siltaxcode !== 'NOTAX' &&
            !isEmpty(array[i]?.siltaxcode) &&
            !isNil(array[i].siltaxtotalamount)
          ? (array[i].siltaxtotalamount / array[i].silnettotalamount) * 100
          : 0;
        recalculate(i, { siltaxrate: taxrate });
      }

      if (_.uniqBy(form.getFieldValue(fieldNameLine), 'ctrid').length > 1)
        form.setFieldsValue({ simultiplecontracts: true });
      else if (
        (isNil(siid) || form.getFieldValue('sistatus') === 'INIT') &&
        !isNil(form.getFieldValue(fieldNameLine)[0]?.ctrid) &&
        !(
          form.getFieldValue('sitype') === 'COMM' ||
          form.getFieldValue('sitype') === 'FEES' ||
          form.getFieldValue('sitype') === 'EXPENSE'
        )
      ) {
        let ctr = form.getFieldValue(fieldNameLine)[0]?.sildescription;
        ctr = ctr?.substr(0, ctr?.indexOf('-'));

        form.setFieldsValue({
          simultiplecontracts: false,
          ctreference: ctr,
          ctrid: form.getFieldValue(fieldNameLine)[0]?.ctrid,
        });
      }
    }
  });

  const addRow = async () => {
    const itemLine: SuppInvoiceLineResponse = {
      silid: Math.round(_.random(10000) * 10000000),
      siltype: form.getFieldValue('sitype'),
      silcategory: '',
      sildescription: '',
      sildescription2: '',
      siid: 0,
      sildiscountperc: 0,
      silgrosstotalamount: 0,
      silnettotalamount: 0,
      silnetunitamountafterd: 0,
      silnetunitmount: 0,
      silorder: 0,
      silquantity: 1,
      siltaxcode: '',
      siltaxrate: 0,
      siltaxtotalamount: 0,
      assetid: 0,
      compid: 0,
      ctrid: -1,
      psid: 0,
      sfid: 0,
    };

    addLine(itemLine);
    //auto add schedule

    if (
      !form
        .getFieldValue(fieldNameSch)
        .find((sch: any) => sch.sistype === 'PAYMENT')
    ) {
      let benef: any;
      await findSIBeneficiary({
        tpid: Number(form.getFieldValue('supplier')?.tpid),
        role: 'SUPPLIER',
        ctrid: form.getFieldValue('ctrid'),
      }).then((resp) => {
        benef = resp.list?.find(
          (benf: any) =>
            benf.tpid === Number(form.getFieldValue('supplier')?.tpid)
        );
      });

      let newDatebenef = moment();
      if (!isNil(benef?.tppaydelayout))
        newDatebenef = moment().add(
          benef?.tppaydelayout
            ?.replace('M', '')
            .substr(1, benef?.tppaydelayout?.length),
          'days'
        );

      if (benef?.tppaydelayout?.indexOf('M') > -1) {
        newDatebenef = moment()
          .add(
            benef?.tppaydelayout
              ?.replace('M', '')
              .substr(1, benef?.tppaydelayout?.length),
            'days'
          )
          .endOf('month');
      }
      const newsisorder = form.getFieldValue(fieldNameSch).length + 1;

      const itemSch: any = {
        siscategory: '',
        sislabel: '',
        sisid: Math.round(_.random(10000) * 10000000),
        sisamount: 0,
        sisdueamount: 0,
        sisduedate: newDatebenef as any,
        sisorder: newsisorder,
        sispaymentdelaycode: benef?.tppaydelayout,
        sispaymentmode: benef?.tppaymodeout,
        sisstatus: 'INIT',
        sistype: 'PAYMENT',
        mgbankaccount: '',
        tpidbeneficiary: form.getFieldValue('supplier').tpid,
        tpbeneficiarybankaccount: benef?.tpbklist.find(
          (bk: any) =>
            bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
        )?.tpbkid,
        sispercentage: 0,
        ctrid: form.getFieldValue('ctrid'),
      };
      addsch(itemSch);
    }

    //get benefTresor data
    let benefTresor: any;
    if (!isNaN(Number(form.getFieldValue('tpidTresor'))))
      (async () => {
        await findSIBeneficiary({
          tpid: Number(form.getFieldValue('tpidTresor')),
          role: 'SUPPLIER',
          ctrid: form.getFieldValue('ctrid'),
        }).then((resp) => {
          benefTresor =
            resp.list?.find(
              (benf: any) =>
                benf.tpid === Number(form.getFieldValue('tpidTresor'))
            ) ?? {};
          setbenefTresor(benefTresor);
        });

        if (!isNil(benefTresor?.tppaydelayout))
          setnewDatebenef(
            moment().add(
              benefTresor?.tppaydelayout
                ?.replace('M', '')
                .substr(1, benefTresor?.tppaydelayout?.length),
              'days'
            ) ?? moment()
          );
        if (benefTresor?.tppaydelayout?.indexOf('M') > -1) {
          setnewDatebenef(
            moment()
              .add(
                benefTresor?.tppaydelayout
                  ?.replace('M', '')
                  .substr(1, benefTresor?.tppaydelayout?.length),
                'days'
              )
              .endOf('month')
          );
        }
      })();
  };
  const handleChangeCtreferenceLines = (ctridd: any) => {
    const list = form.getFieldValue('listAsset');
    const res = list.filter((rowItem: any) => rowItem.ctrid === ctridd);
    form.setFieldsValue({ suppInvoiceLines: res });
    form.setFieldsValue({ ctrid: ctridd });
    const schedule = {
      sisamount: 0,
      sistype: 'PAYMENT',
      tpidbeneficiary: 0,
      sispaymentdelaycode: '',
      sisduedate: '',
      sispaymentmode: '',
      tpbeneficiarybankaccount: '',
      mgbankaccount: '',
      sisstatus: '',
      sisdueamount: '',
    };
    res.map((asset: any) => {
      schedule.sisamount += asset.sisamount;
      schedule.tpidbeneficiary = asset.tpidbeneficiary;
      return null;
    });
    const res2 = [schedule];
    form.setFieldsValue({ suppInvoiceSchedules: res2 });
  };

  const recalculate = useCallback(
    async (index: number, updatedValues: any) => {
      const values = form.getFieldValue(fieldNameLine);
      const newValues = values.map((item: any, i: number) => {
        if (i !== index) {
          return item;
        }
        const updatedItem = { ...item, ...updatedValues };
        const silnetunitmount = updatedItem.silnetunitmount;
        const taxrate = !updatedItem.siltaxrate ? 0 : updatedItem.siltaxrate;

        const silnetunitamountafterd =
          updatedItem.sildiscountperc > 0
            ? silnetunitmount -
              silnetunitmount * (updatedItem.sildiscountperc / 100)
            : silnetunitmount;
        const silnettotalamount = item?.sfid
          ? item.silnettotalamount
          : silnetunitamountafterd * updatedItem.silquantity;
        const siltaxtotalamount =
          silnettotalamount * (taxrate / 100) === 0
            ? updatedValues.siltaxrate === 0
              ? 0
              : item.siltaxtotalamount
            : silnettotalamount * (taxrate / 100);
        const silgrosstotalamount = silnettotalamount + siltaxtotalamount;
        // updatedItem.sisamount !== 0 && !isNil(updatedItem.sisamount)
        //   ? updatedItem.sisamount
        //   :

        return {
          ...updatedItem,
          sildescription: item?.ctreference
            ? item?.ctreference + ' - ' + item?.sillabel
            : item.sildescription,
          silnetunitmount,
          silnetunitamountafterd,
          silnettotalamount,
          siltaxtotalamount,
          silgrosstotalamount,
        };
      });

      const silnettotalamount = sumBy(newValues, 'silnettotalamount');
      const sitaxtotal = sumBy(newValues, 'siltaxtotalamount');
      const sigrosstotal = sumBy(newValues, 'silgrosstotalamount');
      // isNil(sumBy(newValues, 'sisamount'))
      // ?
      // : sumBy(newValues, 'sisamount')

      //gettax from configuration
      let listTax = form.getFieldValue('listHoldingTax') ?? [];
      let finalTaxList = listTax?.filter(
        (e: MgWithHoldingTax) =>
          sigrosstotal > e.siamountmin &&
          (e.siamountmax !== null ? sigrosstotal < e.siamountmax : true)
      );
      const scheduleWithTax = {
        sisamount: 0,
        sistype: 'WITHTAX',
        tpidbeneficiary: Number(form.getFieldValue('tpidTresor')),
        sisduedate: isEmpty(newDatebenef) ? '' : newDatebenef,
        mgbankaccount: '',
        sisstatus: '',
        sisdueamount: '',
        ctrid: form.getFieldValue('ctrid'),
        sispaymentdelaycode: benefTresor?.tppaydelayout,
        sispaymentmode: benefTresor?.tppaymodeout,
        tpbeneficiarybankaccount: benefTresor?.tpbklist?.find(
          (bk: any) =>
            bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
        )?.tpbkid,
        tpbkid: benefTresor?.tpbklist?.find(
          (bk: any) =>
            bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
        )?.tpbkid,
        sisid: Math.round(_.random(10000) * 10000000),
      };
      let newscheduletax = finalTaxList.map((element: MgWithHoldingTax) => {
        return {
          ...scheduleWithTax,
          sisamount:
            element.whtevaluationmode === 'PERC'
              ? (sigrosstotal * element.whtpercentage) / 100
              : element.whtfixedamount,
          sisdueamount:
            element.whtevaluationmode === 'PERC'
              ? (sigrosstotal * element.whtpercentage) / 100
              : element.whtfixedamount,
        };
      });
      let totaltaxamount = sumBy(newscheduletax, 'sisamount');
      let totalholdback = sumBy(
        form
          .getFieldValue(fieldNameSch)
          .filter((sch: any) => sch.sistype === 'HOLDBACK'),
        'sisamount'
      );
      let newSchedule = form.getFieldValue(fieldNameSch).map((sch: any) => {
        if (sch.sistype === 'PAYMENT')
          return {
            ...sch,
            sisamount: sigrosstotal - totaltaxamount - totalholdback,
            sisdueamount: sigrosstotal - totaltaxamount - totalholdback,
          };
        else return sch;
      });
      if (!isEmpty(newscheduletax))
        if (newSchedule.find((sch: any) => sch.sistype === 'WITHTAX'))
          newSchedule.map((sch: any) => {
            if (sch.sistype === 'WITHTAX') return newscheduletax;
            else return sch;
          });
        else {
          newSchedule = newSchedule.concat(newscheduletax);
        }
      else {
        newSchedule = newSchedule.filter(
          (sch: any) => sch.sistype !== 'WITHTAX'
        );
      }

      form.setFieldsValue({
        [fieldNameLine]: newValues,
        [fieldNameSch]: newSchedule,
        sisamount: sigrosstotal,
        silnettotalamount,
        sitaxtotal,
        sigrosstotal,
      });
    },
    [benefTresor, form, newDatebenef]
  );

  const type = form.getFieldValue('siltype');
  const columns: DataGridColDef<SuppInvoiceLineResponse>[] = [
    {
      comcode: 'SILines.silorder',
      key: 'silorder',
      width: 40,
      align: 'right',
      render: (_value, _record, index) => (
        <Form.Item noStyle shouldUpdate>
          <Form.Item name={[fieldNameLine, index, 'silorder']}>
            <Text>{index + 1}</Text>
          </Form.Item>
        </Form.Item>
      ),
    },
    {
      comcode: 'SILines.siltype',
      key: 'siltype',
      width: 150,
      render: (_, record, index) => (
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => (
            <Form.Item
              name={[fieldNameLine, index, 'siltype']}
              rules={[{ required: true }]}
            >
              <ParListSelect
                parcode="SILTYPE"
                disabled
                parvalueparent={getFieldValue('sitype')}
              />
            </Form.Item>
          )}
        </Form.Item>
      ),
    },

    {
      comcode: 'SILines.silcategory',
      key: 'silcategory',
      width: 210,

      render: (_, record, index) => (
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => (
            <Form.Item
              name={[fieldNameLine, index, 'silcategory']}
              rules={[{ required: false }]}
            >
              <ParListSelect
                parcode="SILCAT"
                parvalueparent={getFieldValue([
                  fieldNameLine,
                  index,
                  'siltype',
                ])}
                disabled={record.ctrid !== -1}
              />
            </Form.Item>
          )}
        </Form.Item>
      ),
    },
    {
      comcode: 'SILines.sildescription',
      key: 'sildescription',
      width: 400,
      render: (_value, _record, index) => {
        return (
          <Form.Item
            name={[fieldNameLine, index, 'sildescription']}
            rules={[{ required: true }]}
          >
            <Input
              disabled={
                _record.ctrid !== -1 &&
                _record.sildescription !== '' &&
                !isNil(_record.sildescription)
              }
            />
          </Form.Item>
        );
      },
    },
    {
      comcode: 'silnetunitmount',
      dataIndex: 'silnetunitmount',
      width: 150,
      align: 'right',
      render: (_value, _record, index) => (
        <Form.Item
          name={[fieldNameLine, index, 'silnetunitmount']}
          rules={[{ required: true }]}
        >
          <InputCurrency
            currcode={form.getFieldValue('currcode')}
            onChange={(value) => recalculate(index, { silnetunitmount: value })}
            // disabled={_record.ctrid !== -1}
          />
        </Form.Item>
      ),
    },
    {
      comcode: 'SILines.sildiscountperc',
      key: 'sildiscountperc',
      width: 120,
      align: 'right',
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'sildiscountperc']}>
          <InputRate
            defaultValue={0}
            onChange={(value) => recalculate(index, { sildiscountperc: value })}
            disabled={_record.ctrid !== -1}
            min={0}
            style={{ width: '100%' }}
          />
        </Form.Item>
      ),
    },

    {
      comcode: 'SILines.silnetunitamountafterd',
      key: 'silnetunitamountafterd',
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'silnetunitamountafterd']}>
          <Value
            formatter={(val) => toCurrency(val, form.getFieldValue('currcode'))}
          />
        </Form.Item>
      ),
      width: 120,
      align: 'right',
    },
    {
      comcode: 'SILines.silquantity',
      dataIndex: 'silquantity',
      width: 100,
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'silquantity']}>
          <InputNumber
            onChange={(value) => recalculate(index, { silquantity: value })}
            disabled={_record.ctrid !== -1}
            min={0}
          />
        </Form.Item>
      ),
      align: 'right',
    },
    {
      comcode: 'SILines.silnettotalamount',
      key: 'silnettotalamount',
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'silnettotalamount']}>
          <Value
            formatter={(val) => toCurrency(val, form.getFieldValue('currcode'))}
          />
        </Form.Item>
      ),
      width: 120,
      align: 'right',
    },
    {
      comcode: 'SILines.siltaxcode',
      key: 'siltaxcode',
      width: 150,
      render: (_, record, index) => (
        <Form.Item
          name={[fieldNameLine, index, 'siltaxcode']}
          rules={[{ required: true }]}
        >
          <TaxSelect
            taxflow="INOUT"
            onSelected={(tax) =>
              recalculate(index, { siltaxrate: tax?.taxrate })
            }
          />
        </Form.Item>
      ),
    },

    {
      comcode: 'SILines.siltaxrate',
      dataIndex: 'siltaxrate',
      width: 100,
      render: (_value, _record, index) => {
        return (
          <Form.Item name={[fieldNameLine, index, 'siltaxrate']}>
            <Value />
          </Form.Item>
        );
      },
      align: 'right',
    },
    {
      comcode: 'SILines.siltaxtotalamount',
      key: 'comptaxamount',
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'siltaxtotalamount']}>
          <Value
            formatter={(val) => toCurrency(val, form.getFieldValue('currcode'))}
          />
        </Form.Item>
      ),
      width: 120,
      align: 'right',
    },

    {
      comcode: 'SILines.silgrosstotalamount',
      key: 'silgrosstotalamount',
      render: (_value, _record, index) => (
        <Form.Item name={[fieldNameLine, index, 'silgrosstotalamount']}>
          <Value
            formatter={(val) => toCurrency(val, form.getFieldValue('currcode'))}
          />
        </Form.Item>
      ),
      fixed: 'right',
      width: 120,
      align: 'right',
    },
  ];

  if (siid === undefined) {
    columns.push({
      title: 'Actions',
      key: 'actions',
      render: (_value, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => {
            removeLine(record.silid);
          }}
        >
          <Button
            comcode="delete"
            size="small"
            icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
          />
        </Popconfirm>
      ),
      fixed: 'right',
      width: 120,
    });
  }
  if (type === 'Asset') {
    columns.splice(2, 1);
  }

  // if (simultiplecontracts) {
  //   columns.unshift({
  //     comcode: 'SILines.ctrid',
  //     key: 'ctrid',
  //     width: 180,
  //     render: (_value, _record, index) => (
  //       <Form.Item noStyle shouldUpdate>
  //         {({ getFieldValue }) => (
  //           <Form.Item name={[fieldNameLine, index, 'ctrid']}>
  //             <Select
  //               showSearch
  //               showArrow={false}
  //               allowClear
  //               onSelect={(e) => handleChangeCtreferenceLines(e)}
  //               style={{ width: '100%' }}
  //             >
  //               {getFieldValue('listAsset')?.map((d: any) => (
  //                 <Option key={d.value} value={d.value}>
  //                   {d.text}
  //                 </Option>
  //               ))}
  //             </Select>
  //           </Form.Item>
  //         )}
  //       </Form.Item>
  //     ),
  //   });
  // }

  const title = (
    <Form.Item
      noStyle
      shouldUpdate={shouldUpdateCompare([
        'silnettotalamount',
        'sitaxtotal',
        'sigrosstotal',
        'currcode',
      ])}
    >
      {({ getFieldValue }) => {
        return (
          <Space size={16}>
            <span style={{ color: '#668cff' }}>
              Net:{' '}
              {toCurrency(
                getFieldValue('silnettotalamount'),
                getFieldValue('currcode')
              )}
            </span>
            <span style={{ color: '#b3c6ff' }}>
              Tax:{' '}
              {toCurrency(
                getFieldValue('sitaxtotal'),
                getFieldValue('currcode')
              )}
            </span>
            <strong style={{ color: '#668cff' }}>
              Gross:{' '}
              {toCurrency(
                getFieldValue('sigrosstotal'),
                getFieldValue('currcode')
              )}
            </strong>
          </Space>
        );
      }}
    </Form.Item>
  );

  return (
    <Form.Item
      noStyle
      shouldUpdate={shouldUpdateCompare(['suppInvoiceLines', 'sistatus'])}
    >
      {({ getFieldValue }) => {

        return (
          <div>
            {siid === undefined || getFieldValue('sistatus') === 'INIT' ? (
              <DataGrid
                title={title}
                columns={columns}
                dataSource={getFieldValue(fieldNameLine)}
                rowKey="silid"
                hideFilters
                extraActions={
                  <ButtonOperation
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={addRow}
                    comcode="add"
                  />
                }
              />
            ) : (
              <DataGrid
                title={title}
                columns={columns}
                dataSource={getFieldValue(fieldNameLine)}
                rowKey="silid"
              />
            )}{' '}
          </div>
        );
      }}
    </Form.Item>
  );
};
export default TabSuppInvoiceLines;
